<template>
    <el-dialog
        title="个性化设置"
        :visible.sync="MakerDialogVisible"
        width="50%"
        :center="true"
        :append-to-body="true"
        :close-on-click-modal="false"
        :before-close="() => CloseMakerDialog('MakerForm')"
    >
        <div style="margin-bottom: 5px;text-align: center;">
            <el-radio-group v-model="type" size="small">
                <el-radio-button label="mark">个性签名</el-radio-button>
                <el-radio-button label="chat">气泡颜色</el-radio-button>
                <el-radio-button label="title">自定头衔</el-radio-button>
                <el-radio-button label="room">房间名称</el-radio-button>
            </el-radio-group>
        </div>

        <el-form
            v-if="type === 'mark'"
            :model="Maker"
            ref="MakerForm"
            label-width="100px"
        >
            <el-descriptions
                class="margin-top"
                :column="1"
                :labelStyle="{'width':'100px','text-align':'center'}"
                :contentStyle="{'text-align': 'center'}"
                border
            >
                <el-descriptions-item :contentStyle="{'font-size':'18px','text-align': 'center','color':'#9F35FF','font-weight':'bold','white-space':'pre-line'}">
                    <template slot="label">
                        <span>原签名</span>
                    </template>
                    <span>{{ OldMaker }}</span>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <span>新签名</span>
                    </template>
                    <el-input
                        type="textarea"
                        :rows="3"
                        resize="none"
                        :maxlength="30"
                        show-word-limit
                        v-model="Maker.maker"
                        clearable
                        class="maker_c"
                    ></el-input>
                </el-descriptions-item>
            </el-descriptions>
        </el-form>
        <el-form
            v-else-if="type === 'chat'"
            :model="ChatTxt"
            ref="ChatForm"
            label-width="100px"
        >
            <el-descriptions
                class="margin-top"
                :column="1"
                :labelStyle="{'width':'100px','text-align':'center'}"
                :contentStyle="{'text-align': 'center'}"
                border
            >
                <el-descriptions-item :contentStyle="{'font-size':'18px','text-align': 'center','font-weight':'bold','white-space':'pre-line'}">
                    <template slot="label">
                        <span>预览</span>
                    </template>
                    <div :style="'color: '+ChatTxt.color">这是一段聊天文字</div>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <span>颜色</span>
                    </template>
                    <el-color-picker v-model="ChatTxt.color"></el-color-picker>
                </el-descriptions-item>
            </el-descriptions>
        </el-form>
        <el-form
            v-else-if="type === 'title'"
            :model="TitleTxt"
            ref="TxtForm"
            label-width="100px"
        >
            <el-descriptions
                class="margin-top"
                :column="1"
                :labelStyle="{'width':'100px','text-align':'center'}"
                :contentStyle="{'text-align': 'center'}"
                border
            >
                <el-descriptions-item :contentStyle="{'font-size':'18px','text-align': 'center','font-weight':'bold','white-space':'pre-line'}">
                    <template slot="label">
                        <span>预览</span>
                    </template>
                    <span v-if="TitleTxt.txt1" :style="'color: '+TitleTxt.color1">{{ TitleTxt.txt1 }}</span>
                    <span v-if="TitleTxt.txt2" :style="'color: '+TitleTxt.color2">{{ TitleTxt.txt2 }}</span>
                    <span v-if="TitleTxt.txt3" :style="'color: '+TitleTxt.color3">{{ TitleTxt.txt3 }}</span>
                    <span v-if="TitleTxt.txt4" :style="'color: '+TitleTxt.color4">{{ TitleTxt.txt4 }}</span>
                    <span v-if="TitleTxt.txt5" :style="'color: '+TitleTxt.color5">{{ TitleTxt.txt5 }}</span>
                    <span v-if="TitleTxt.txt6" :style="'color: '+TitleTxt.color6">{{ TitleTxt.txt6 }}</span>
                    <span v-if="TitleTxt.txt7" :style="'color: '+TitleTxt.color7">{{ TitleTxt.txt7 }}</span>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <span>头衔</span>
                    </template>
                    <el-input v-model="TitleTxt.txt" :maxlength='7' @input="title_change"></el-input>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <span>颜色</span>
                    </template>
                    <el-color-picker v-if="TitleTxt.txt1" v-model="TitleTxt.color1"></el-color-picker>
                    <el-color-picker v-if="TitleTxt.txt2" v-model="TitleTxt.color2"></el-color-picker>
                    <el-color-picker v-if="TitleTxt.txt3" v-model="TitleTxt.color3"></el-color-picker>
                    <el-color-picker v-if="TitleTxt.txt4" v-model="TitleTxt.color4"></el-color-picker>
                    <el-color-picker v-if="TitleTxt.txt5" v-model="TitleTxt.color5"></el-color-picker>
                    <el-color-picker v-if="TitleTxt.txt6" v-model="TitleTxt.color6"></el-color-picker>
                    <el-color-picker v-if="TitleTxt.txt7" v-model="TitleTxt.color7"></el-color-picker>
                </el-descriptions-item>
            </el-descriptions>
        </el-form>
        <el-form
            v-else-if="type === 'room'"
            :model="Room"
            ref="RoomForm"
            label-width="100px"
        >
            <el-descriptions
                class="margin-top"
                :column="1"
                :labelStyle="{'width':'100px','text-align':'center'}"
                :contentStyle="{'text-align': 'center'}"
                border
            >
                <el-descriptions-item :contentStyle="{'font-size':'18px','text-align': 'center','color':'#2828FF','font-weight':'bold','white-space':'pre-line'}">
                    <template slot="label">
                        <span>原房名</span>
                    </template>
                    <span>{{ OldRoom }}</span>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <span>新房名</span>
                    </template>
                    <el-input :maxlength="10" v-model="Room.name" clearable></el-input>
                </el-descriptions-item>
            </el-descriptions>
        </el-form>
        <div slot="footer">
            <el-button v-if="type === 'room'" type="primary" plain @click="SubmitMaker('RoomForm')">确 定</el-button>
            <el-button v-else type="primary" plain @click="SubmitMaker('MakerForm')">确 定</el-button>
            <el-button plain @click="CloseMakerDialog('MakerForm')">取 消</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { MakerChangeRequest,ChatColorRequest,TitleRequest,RoomChangeRequest } from '@/network/user.js'

export default {
    name: 'MakerDialogComponent',
    data() {
        return {
            type: 'mark',
            Maker: {
                maker: ''
            },
            ChatTxt: {
                color: '#000000'
            },
            TitleTxt: {
                txt: '',
                txt1: '',
                txt2: '',
                txt3: '',
                txt4: '',
                txt5: '',
                txt6: '',
                txt7: '',
                color1: '#000000',
                color2: '#000000',
                color3: '#000000',
                color4: '#000000',
                color5: '#000000',
                color6: '#000000',
                color7: '#000000'
            },
            Room: {
                name: ''
            }
        }
    },
    computed: {},
    methods: {
        CloseMakerDialog(formName) {
            this.Maker.maker = ''
            this.Room.name = ''
            this.ChatTxt.color = this.OldChatColor
            this.TitleTxt.txt = this.title
            this.title_change(this.title)
            for(let i=0;i<7;i++)
            {
                this.TitleTxt['color'+(1+i*1)] = this.titlecolor[i]
            }

            this.$emit('ExitMakerDialog')
        },
        SubmitMaker(formName) {
            if(this.type === 'mark') {
                this.$refs[formName].validate((valid) => {
                    if (!valid) {
                        return
                    }

                    if (this.Maker.maker === '') {
                        this.$message.error('请填写新签名')
                        return
                    }
                    
                    if (this.Maker.maker == this.OldMaker) {
                        this.$message.error('新签名与原签名一致')
                        return
                    }

                    MakerChangeRequest(this.Maker)
                        .then((s) => {
                            if (s.status === 0) {
                                this.$emit('EditMaker',this.Maker.maker)    //修改主页的签名显示
                                this.$message.success('修改成功!')
                                this.CloseMakerDialog(formName)
                            } else {
                                this.$message.error(s.msg)
                            }
                        })
                        .catch((err) => {
                            console.log(err)
                        })
                })
            } else if(this.type === 'chat') {
                ChatColorRequest(this.ChatTxt)
                    .then((s) => {
                        if (s.status === 0) {
                            this.$emit('EditChatTxt',this.ChatTxt.color)
                            this.$message.success('修改成功!')
                            this.CloseMakerDialog(formName)
                        } else {
                            this.$message.error(s.msg)
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            } else if(this.type === 'title') {
                TitleRequest(this.TitleTxt)
                    .then((s) => {
                        if (s.status === 0) {
                            this.$emit('EditTitleTxt',this.TitleTxt)
                            this.$message.success('修改成功!')
                            this.CloseMakerDialog(formName)
                        } else {
                            this.$message.error(s.msg)
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            } else if(this.type === 'room') {
                this.$refs[formName].validate((valid) => {
                    if (!valid) {
                        return
                    }

                    if (this.Room.name === '') {
                        this.$message.error('请填写新房名')
                        return
                    }
                    
                    if (this.Room.name == this.OldRoom) {
                        this.$message.error('新房名与原房名一致')
                        return
                    }

                    RoomChangeRequest(this.Room)
                        .then((s) => {
                            if (s.status === 0) {
                                this.$emit('EditRoom',this.Room.name)
                                this.$message.success('修改成功!')
                                this.CloseMakerDialog(formName)
                            } else {
                                this.$message.error(s.msg)
                            }
                        })
                        .catch((err) => {
                            console.log(err)
                        })
                })
            }
        },
        title_change(v) {
            this.TitleTxt.txt1 = ''
            this.TitleTxt.txt2 = ''
            this.TitleTxt.txt3 = ''
            this.TitleTxt.txt4 = ''
            this.TitleTxt.txt5 = ''
            this.TitleTxt.txt6 = ''
            this.TitleTxt.txt7 = ''
            for(let i = 0;i<v.length;i++) {
                this.TitleTxt['txt'+(1+i*1)] = v[i]
            }
            for(let j = 0;j<7;j++) {
                if(this.TitleTxt['txt'+(1+j*1)]) {

                } else {
                    this.TitleTxt['color'+(1+j*1)] = '#000000'
                }
            }
        }
    },
    filters: {},
    props: {
        MakerDialogVisible: Boolean,
        OldMaker: {
            type: String,
            default() {
                return ''
            }
        },
        OldChatColor: {
            type: String,
            default() {
                return '#000000'
            }
        },
        title: {
            type: String,
            default() {
                return '#000000'
            }
        },
        titlecolor: {
            type: Array,
            default() {
                return ['#000000','#000000','#000000','#000000','#000000','#000000','#000000']
            }
        },
        OldRoom: {
            type: String,
            default() {
                return ''
            }
        },
    },
    created() {},
    destoryed() {},
    mounted() {},
    updated() {},
    components: {},
    watch: {
        OldChatColor(newVal) {
            this.ChatTxt.color = newVal
        },
        title(newVal) {
            this.TitleTxt.txt = newVal
            this.title_change(newVal)
        },
        titlecolor(newVal) {
            for(let i=0;i<7;i++)
            {
                this.TitleTxt['color'+(1+i*1)] = newVal[i]
            }
        }
    }
}
</script>